// // Login View urls
// export const ACE_URL = "https://www.acerentalcars.com.au/";
// export const ACE_ONLINE_CHECK_IN = "https://www.acerentalcars.com.au/checkin";
// export const ACE_PRODUCTS_AND_SERVICES =
//   "https://www.acerentalcars.com.au/information/car-rental-accessories";
// export const ACE_FLEET_GUIDE = "https://www.acerentalcars.com.au/our-cars";
// export const ACE_LOCATIONS = "https://www.acerentalcars.com.au/locations/car-hire-locations";

// export const HERTZ_URL = "https://www.hertz.com.au/";
// export const HERTZ_PRODUCTS_AND_SERVICES =
//   "https://www.hertz.com.au/rentacar/productsandservices/productsandservicesRegions.do";
// export const HERTZ_FLEET_GUIDE =
//   "https://www.hertz.com.au/rentacar/vehicleguide/index.jsp?targetPage=vehicleGuideHomeView.jsp&countryCode=AU&category=Car/Sedan";
// export const HERTZ_PRIVACY_POLICY =
//   "https://www.hertz.com/rentacar/privacypolicy/index.jsp?targetPage=privacyPolicyView.jsp";
// export const HERTZ_FLEET_URL = "https://hertzfleet.com.au/";
// export const HERTZ_LOCATIONS = "https://www.hertz.com.au/rentacar/location";
// export const HERTZ_INVOICE_EXPLAINED = "https://images.hertz.com/pdfs/au_invoice_explained.pdf";
// export const HERTZ_JOIN_GOLD_MEMBER =
//   "https://www.hertz.com.au/rentacar/emember/join/overview.do?learnMore=gold";
// export const HERTZ_FAQ = "https://hertz.force.com/care/htz_faqsearchwebform?lang=AU&pos=AU";

// export const FIREFLY_URL = "https://www.fireflycarrental.com/rentalcar/reservation/home";
// export const FIREFLY_LOCATIONS =
//   "https://www.fireflycarrental.com/rentalcar/locations/index.jsp?targetPage=locationsListView.jsp";

// export const DOLLAR_PRIVACY_POLICY="";
// export const THRIFTY_PRIVACY_POLICY="";

// Login View urls
export const ACE_URL = {
  au: "https://www.acerentalcars.com.au/",
  nz: "https://www.acerentalcars.co.nz/"
};
export const ACE_ONLINE_CHECK_IN = {
  au: "https://www.acerentalcars.com.au/checkin",
  nz: "https://www.acerentalcars.co.nz/checkin"
};
export const ACE_PRODUCTS_AND_SERVICES = {
  au: "https://www.acerentalcars.com.au/information/car-rental-accessories",
  nz: "https://www.acerentalcars.co.nz/information/car-rental-accessories"
};
export const ACE_FLEET_GUIDE = {
  au: "https://www.acerentalcars.com.au/our-cars",
  nz: "https://www.acerentalcars.co.nz/our-cars"
};
export const ACE_LOCATIONS = {
  au: "https://www.acerentalcars.com.au/locations/car-hire-locations",
  nz: "https://www.acerentalcars.co.nz/locations/new-zealand-rental-car-locations"
};

export const HERTZ_URL = {
  au: "https://www.hertz.com.au/",
  nz: "https://www.hertz.co.nz/"
};
export const HERTZ_PRODUCTS_AND_SERVICES = {
  au: "https://www.hertz.com.au/rentacar/productsandservices/productsandservicesRegions.do",
  nz: "https://www.hertz.co.nz/rentacar/productsandservices/productsandservicesRegions.do"
};
export const HERTZ_FLEET_GUIDE = {
  au: "https://www.hertz.com.au/rentacar/vehicleguide/index.jsp?targetPage=vehicleGuideHomeView.jsp&countryCode=AU&category=Car/Sedan",
  nz: "https://www.hertz.co.nz/rentacar/vehicleguide/index.jsp?targetPage=vehicleGuideHomeView.jsp&countryCode=NZ&category=Car/Sedan"
};
export const HERTZ_PRIVACY_POLICY =
  "https://www.hertz.com/rentacar/privacypolicy/index.jsp?targetPage=privacyPolicyView.jsp";
export const HERTZ_FLEET_URL = "https://hertzfleet.com.au/";
export const HERTZ_LOCATIONS = {
  au: "https://www.hertz.com.au/rentacar/location",
  nz: "https://www.hertz.co.nz/rentacar/location"
};
export const HERTZ_INVOICE_EXPLAINED = "https://images.hertz.com/pdfs/au_invoice_explained.pdf";
export const HERTZ_JOIN_GOLD_MEMBER =
  "https://www.hertz.com.au/rentacar/emember/join/overview.do?learnMore=gold";
export const HERTZ_FAQ = {
  au: "https://hertz.force.com/care/htz_faqsearchwebform?lang=AU&pos=AU",
  nz: "https://hertz.force.com/care/htz_faqsearchwebform?lang=AU&pos=AU"
};

export const FIREFLY_URL = "https://www.fireflycarrental.com/rentalcar/reservation/home";
export const FIREFLY_URL_NZ = "https://www.fireflycarrental.co.nz/rentalcar/reservation/home";
export const FIREFLY_LOCATIONS = "https://www.fireflycarrental.com/rentalcar/locations/index.jsp?targetPage=locationsListView.jsp";
export const FIREFLY_LOCATIONS_NZ = "https://www.fireflycarrental.co.nz/rentalcar/locations/index.jsp?targetPage=locationsListView.jsp";

export const DOLLAR_PRIVACY_POLICY = "";
export const DOLLAR_PRIVACY_POLICY_NZ = "";
export const THRIFTY_PRIVACY_POLICY = "";
export const THRIFTY_PRIVACY_POLICY_NZ = "";

// Login View icons
// ACE
export const ACE_URL_LOGO =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/logos/ace_rental_cars_logo_400.jpg";
export const ACE_URL_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/ace/Other_Click+Ace.png";
export const ACE_ONLINE_CHECK_IN_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_Loyalty_Join_Transparent.png";
export const ACE_PRODUCTS_AND_SERVICES_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/ace/Loyalty_Cash-and-Points+Ace.png";
export const ACE_FLEET_GUIDE_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/ace/Loyalty_Select-your-Car+Ace.png";
export const ACE_LOCATIONS_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/ace/Other_Parking+Ace.png";
export const ACE_FAVICON_HREF =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/favicon/Ace-AU-favicon.png";
export const ACE_LOGIN_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/MJP+sign+in-Ace.jpg";

// HERTZ
export const HERTZ_URL_LOGO =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/logos/Hertz_Primary_Logo_Black_Yellow+Line_RGB.png";
export const HERTZ_URL_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_Other_Click_Transparent.png";
export const HERTZ_PRODUCTS_AND_SERVICES_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_Loyalty_Cash-and-Points_Transparent.png";
export const HERTZ_FLEET_GUIDE_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_Loyalty_Select-your-Car_Transparent.png";
export const HERTZ_LOCATIONS_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/H_Iconography_Other_Parking_Transparent.png";
export const HERTZ_FAQ_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/Herts+FAQ.png";
export const HERTZ_LOGIN_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/MJP-Sign-In-Banner.jpg";

// FIREFLY
export const FIREFLY_URL_LOGO =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/logos/firefly_logo_final.png";
export const FIREFLY_URL_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/firefly/Other_Click+Firefly.png";
export const FIREFLY_LOCATIONS_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/firefly/Other_Parking+Firefly.png";
export const FIREFLY_FAVICON_HREF =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/favicon/firefly-favicon.ico";
export const FIREFLY_LOGIN_BANNER =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/images/MJP+sign+in-FF.jpg";

//Dollar

export const DOLLAR_URL_LOGO = "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/logos/Dollar_logo_CMYK.jpg"

//Thrifty

export const THRIFTY_URL_LOGO = "https://s3.ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/logos/Thrifty_logo_CMYK.jpg"

// T&C urls
export const HERTZ_TERMS_AU = "https://www.hertz.com.au/terms";
export const HERTZ_TERMS_NZ = "https://www.hertz.co.nz/terms";
export const ACE_TERMS_AU = "https://www.acerentalcars.com.au/terms";
export const ACE_TERMS_NZ = "https://www.acerentalcars.co.nz/terms";
export const FIREFLY_TERMS_AU = "https://www.fireflycarrental.com/termsAU";
export const FIREFLY_TERMS_NZ =
  "https://images.hertz.com/pdfs/Firefly_New_Zealand_Terms_and_Conditions.pdf";
export const THRIFTY_TERMS_AU="https://www.thrifty.com.au/terms";
export const THRIFTY_TERMS_NZ="https://www.thrifty.co.nz/terms-and-conditions/";
export const DOLLAR_TERMS_AU="";
export const DOLLAR_TERMS_NZ="https://www.dollarcarrental.co.nz/terms-conditions/";
  

// Footer Copy
export const ACE_FOOTER_COPY = "";
export const HERTZ_FOOTER_COPY = "";
export const FIREFLY_FOOTER_COPY = "";

// Assets
export const PDF_ICON =
  "https://s3-ap-southeast-2.amazonaws.com/static.hertz.asiapac.io-prod/hertz-style-guide/icons/placeholder-pdf-300x300.jpg";
